import {
  Component,
  HostBinding,
  Input,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'suka-navigation',
  template: `
    <nav role="navigation__container">
      <ul class="navigation__items">
        <ng-content></ng-content>
      </ul>
    </nav>
  `,
  encapsulation: ViewEncapsulation.None
})
export class Navigation {
  @HostBinding('attr.role') role = 'complementary';
  @HostBinding('class.navigation') hostClass = true;
  /**
   * Controls the expanded (`true`) or collapsed (`false`) state when on a small screen.
   */
  @HostBinding('class.navigation--expanded') @Input() expanded = true;
  /**
   * Controls the hidden (`true`) or visible (`false`) state
   */
  @HostBinding('class.navigation--hidden') @Input() hidden = false;
  @HostBinding('class.navigation--rail') @Input() rail = false;
  @Input() allowExpansion = false;

  constructor() { }

  toggle() {
    this.expanded = !this.expanded;
  }
}
